import { Box, Card, Grid, Typography, Button, CardContent, Switch, FormControlLabel } from "@mui/material";
import { useState } from "react";
import InputResolver from "./Inputs/InputResolver";
import Selectors from "./Selectors/Selectors";
import SaveQrCode from "./SaveQrCode";
import Styling from "./Styling/Styling";
import QrCode from "./QrCode";
import TrackPerformanceSwitch from "./TeaseSwitches/TrackPerformanceSwitch";
import RealtimeInsightsSwitch from "./TeaseSwitches/RealtimeInsightsSwitch";

const Creator = () => {
    return (
        <Box sx={{ padding: 4 }}>
            <Card sx={{ padding: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Selectors />
                        <InputResolver />
                        <TrackPerformanceSwitch />
                        <RealtimeInsightsSwitch />
                        <SaveQrCode />
                        <Styling />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card elevation={0} sx={{ backgroundColor: "#F9F9F9" }}>
                            <CardContent>
                                <QrCode />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Card>
        </Box>
    );
};

export default Creator;
